import Image from 'next/image'

import { motion } from 'framer-motion'
import classnames from 'classnames/bind'

import Heading from 'components/Heading'

import styles from './Loading.module.css'
let cx = classnames.bind(styles)

function Loading({ title, center }) {
  return (
    <div className={cx({ loading: true, center: center })}>
      <motion.div
        className={styles['loading-image']}
        animate={{ scale: 1.07 }}
        transition={{
          duration: 1.3,
          repeat: Infinity,
          repeatType: 'reverse',
        }}
      >
        <Image src="/titan-bird.png" alt="Loading..." width={171} height={91} loading="eager" />
      </motion.div>
      {title && (
        <Heading element="h3" size="h2" center>
          {title}
        </Heading>
      )}
    </div>
  )
}

export default Loading
